import React, { useState } from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { Button, LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';

import { useSession } from '@/components/app';
import { useTranslations } from '@/domain/translations';

import { useCreditVippsQuery } from './useCreditVippsQuery';
import { useDebitVippsQuery } from './useDebitVippsQuery';
import { useVippsCookie } from './useVippsCookie';

import './VippsWidget.scss';
import icon from './vipps-icon.svg';

const VippsContent = () => {
    const t = useTranslations();
    const [open, setOpen] = useState(true);
    const debitQuery = useDebitVippsQuery();
    const creditQuery = useCreditVippsQuery();
    const { setCookie } = useVippsCookie();

    if (debitQuery.status !== 'success' && creditQuery.status !== 'success') {
        return null;
    }

    if (!debitQuery.data?.available && !creditQuery.data?.available) {
        return null;
    }

    return (
        <Modal appNamespace="kortbetjening-web" open={open} setOpen={setOpen} onClose={setCookie}>
            <section className="vipps-widget" data-testid="apple-pay-initial-message">
                <img src={icon} alt="vipps icon" />
                <h3>{t.vippsWidget.header}</h3>
                <p>{t.vippsWidget.text1}</p>
                <p>{t.vippsWidget.text2}</p>
                <Button icon={IconTypes.EKSTERN_24} iconOnRightSide>
                    {t.vippsWidget.openVipps}
                </Button>
                <LinkButton>{t.vippsWidget.notNow}</LinkButton>
            </section>
        </Modal>
    );
};

export const VippsWidget = () => {
    const session = useSession();
    const { showModal } = useVippsCookie();
    const enabled = runningInRNWebView && session.toggles.VIPPS && showModal;

    if (!enabled) {
        return null;
    }

    return <VippsContent />;
};
